var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSandWatch = function SvgSandWatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 344 344"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "m271.773 50.857 11.663 11.676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "m271.773 50.857 11.663 11.676M271.773 50.857l11.663 11.676"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "m271.773 62.533 11.663-11.676"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "m271.773 62.533 11.663-11.676M271.773 62.533l11.663-11.676"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "m301.312 78.352 6.894 6.88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "m301.312 78.352 6.894 6.88M301.312 78.352l6.894 6.88"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "m301.312 85.232 6.894-6.88"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "m301.312 85.232 6.894-6.88M301.312 85.232l6.894-6.88"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "m315.842 195.649 6.88 6.88"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "m315.842 195.649 6.88 6.88M315.842 195.649l6.88 6.88"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "m315.842 202.529 6.88-6.88"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "m315.842 202.529 6.88-6.88M315.842 202.529l6.88-6.88"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "m162.851 280.872 13.161 13.174"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "m162.851 280.872 13.161 13.174M162.851 280.872l13.161 13.174"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "m162.851 294.046 13.161-13.174"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "m162.851 294.046 13.161-13.174M162.851 294.046l13.161-13.174"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "m26.594 269.44 23.69 23.676"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "m26.594 269.44 23.69 23.676M26.594 269.44l23.69 23.676"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "m26.594 293.116 23.69-23.676"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "m26.594 293.116 23.69-23.676M26.594 293.116l23.69-23.676"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M279.526 108.255a4.144 4.144 0 1 0 0-8.287 4.144 4.144 0 0 0 0 8.287Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M279.526 108.255a4.144 4.144 0 1 0 0-8.287 4.144 4.144 0 0 0 0 8.287Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M279.526 108.255a4.144 4.144 0 1 0 0-8.287 4.144 4.144 0 0 0 0 8.287Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M308.218 224.095a3.101 3.101 0 1 0 .001-6.203 3.101 3.101 0 0 0-.001 6.203Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M308.218 224.095a3.101 3.101 0 1 0 .001-6.203 3.101 3.101 0 0 0-.001 6.203Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M308.218 224.095a3.101 3.101 0 1 0 .001-6.203 3.101 3.101 0 0 0-.001 6.203Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M201.604 256.825a3.987 3.987 0 1 0 .002-7.974 3.987 3.987 0 0 0-.002 7.974Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M201.604 256.825a3.987 3.987 0 1 0 .002-7.974 3.987 3.987 0 0 0-.002 7.974Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M201.604 256.825a3.987 3.987 0 1 0 .002-7.974 3.987 3.987 0 0 0-.002 7.974Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M28.782 251.316a2.997 2.997 0 1 0 0-5.994 2.997 2.997 0 0 0 0 5.994Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M28.782 251.316a2.997 2.997 0 1 0 0-5.994 2.997 2.997 0 0 0 0 5.994Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M28.782 251.316a2.997 2.997 0 1 0 0-5.994 2.997 2.997 0 0 0 0 5.994Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M81.492 302.421a2.997 2.997 0 1 0 0-5.994 2.997 2.997 0 0 0 0 5.994Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M81.492 302.421a2.997 2.997 0 1 0 0-5.994 2.997 2.997 0 0 0 0 5.994Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M81.492 302.421a2.997 2.997 0 1 0 0-5.994 2.997 2.997 0 0 0 0 5.994Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M94.002 321.236a5.212 5.212 0 1 0 0-10.425 5.212 5.212 0 0 0 0 10.425Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M94.002 321.236a5.212 5.212 0 1 0 0-10.425 5.212 5.212 0 0 0 0 10.425Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M94.002 321.236a5.212 5.212 0 1 0 0-10.425 5.212 5.212 0 0 0 0 10.425Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg)",
    d: "M325.81 127.54H196.875v17.304H325.81z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M325.81 127.54H196.875v17.304H325.81z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M325.81 127.54H196.875v17.304H325.81z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M325.81 127.54H196.875v17.304H325.81z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg)",
    d: "M325.81 302.433H196.875v17.304H325.81z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M325.81 302.433H196.875v17.304H325.81z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M325.81 302.433H196.875v17.304H325.81z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M325.81 302.433H196.875v17.304H325.81z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg)",
    d: "M305.522 172.364v-27.559h-88.346v27.559a39.55 39.55 0 0 0 19.142 33.892l8.131 4.899a14.08 14.08 0 0 1 6.815 12.066c0 4.939-2.593 9.525-6.815 12.066l-8.131 4.9a39.58 39.58 0 0 0-19.142 33.891v28.302h88.346v-28.302a39.55 39.55 0 0 0-19.142-33.891l-8.131-4.9a14.08 14.08 0 0 1-6.815-12.066c0-4.938 2.593-9.525 6.815-12.066l8.131-4.899a39.61 39.61 0 0 0 19.142-33.892"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M305.522 172.364v-27.559h-88.346v27.559a39.55 39.55 0 0 0 19.142 33.892l8.131 4.899a14.08 14.08 0 0 1 6.815 12.066c0 4.939-2.593 9.525-6.815 12.066l-8.131 4.9a39.58 39.58 0 0 0-19.142 33.891v28.302h88.346v-28.302a39.55 39.55 0 0 0-19.142-33.891l-8.131-4.9a14.08 14.08 0 0 1-6.815-12.066c0-4.938 2.593-9.525 6.815-12.066l8.131-4.899a39.61 39.61 0 0 0 19.142-33.892Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M305.522 172.364v-27.559h-88.346v27.559a39.55 39.55 0 0 0 19.142 33.892l8.131 4.899a14.08 14.08 0 0 1 6.815 12.066c0 4.939-2.593 9.525-6.815 12.066l-8.131 4.9a39.58 39.58 0 0 0-19.142 33.891v28.302h88.346v-28.302a39.55 39.55 0 0 0-19.142-33.891l-8.131-4.9a14.08 14.08 0 0 1-6.815-12.066c0-4.938 2.593-9.525 6.815-12.066l8.131-4.899a39.61 39.61 0 0 0 19.142-33.892Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M305.522 172.364v-27.559h-88.346v27.559a39.55 39.55 0 0 0 19.142 33.892l8.131 4.899a14.08 14.08 0 0 1 6.815 12.066c0 4.939-2.593 9.525-6.815 12.066l-8.131 4.9a39.58 39.58 0 0 0-19.142 33.891v28.302h88.346v-28.302a39.55 39.55 0 0 0-19.142-33.891l-8.131-4.9a14.08 14.08 0 0 1-6.815-12.066c0-4.938 2.593-9.525 6.815-12.066l8.131-4.899a39.61 39.61 0 0 0 19.142-33.892Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "m234.804 302.328 20.771-19.272c3.674-3.414 9.368-3.348 12.978.131l19.845 19.167z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "m234.804 302.328 20.771-19.272c3.674-3.414 9.368-3.348 12.978.131l19.845 19.167z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "m234.804 302.328 20.771-19.272c3.674-3.414 9.368-3.348 12.978.131l19.845 19.167z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M290.497 203.403s-7.974-14.607-30.087-14.607c-18.985 0-29.122 13.825-29.122 13.825 1.485 1.981 8.795 6.085 13.147 8.522s6.815 7.206 6.815 12.066c0 5.538 2.411 16.64 3.961 23.259a6.74 6.74 0 0 0 1.473 2.88c.703.821.808 1.941.325 2.905-.573 1.147-.768 2.528-.404 3.975.509 1.98 2.124 3.57 4.118 4.026 3.701.86 6.997-1.941 6.997-5.486 0-.964-.247-1.876-.677-2.658-.521-.951-.482-2.072.208-2.919a6.8 6.8 0 0 0 1.408-3.075c1.133-6.476 2.775-16.952 2.775-22.881 0-5.382 2.932-10.072 7.245-12.392 6.671-3.609 11.818-7.44 11.818-7.44Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M290.497 203.403s-7.974-14.607-30.087-14.607c-18.985 0-29.122 13.825-29.122 13.825 1.485 1.981 8.795 6.085 13.147 8.522s6.815 7.206 6.815 12.066c0 5.538 2.411 16.64 3.961 23.259a6.74 6.74 0 0 0 1.473 2.88c.703.821.808 1.941.325 2.905-.573 1.147-.768 2.528-.404 3.975.509 1.98 2.124 3.57 4.118 4.026 3.701.86 6.997-1.941 6.997-5.486 0-.964-.247-1.876-.677-2.658-.521-.951-.482-2.072.208-2.919a6.8 6.8 0 0 0 1.408-3.075c1.133-6.476 2.775-16.952 2.775-22.881 0-5.382 2.932-10.072 7.245-12.392 6.671-3.609 11.818-7.44 11.818-7.44Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M290.497 203.403s-7.974-14.607-30.087-14.607c-18.985 0-29.122 13.825-29.122 13.825 1.485 1.981 8.795 6.085 13.147 8.522s6.815 7.206 6.815 12.066c0 5.538 2.411 16.64 3.961 23.259a6.74 6.74 0 0 0 1.473 2.88c.703.821.808 1.941.325 2.905-.573 1.147-.768 2.528-.404 3.975.509 1.98 2.124 3.57 4.118 4.026 3.701.86 6.997-1.941 6.997-5.486 0-.964-.247-1.876-.677-2.658-.521-.951-.482-2.072.208-2.919a6.8 6.8 0 0 0 1.408-3.075c1.133-6.476 2.775-16.952 2.775-22.881 0-5.382 2.932-10.072 7.245-12.392 6.671-3.609 11.818-7.44 11.818-7.44Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M262.067 266.704a2.81 2.81 0 0 0-2.815 2.815 2.81 2.81 0 0 0 2.815 2.814 2.81 2.81 0 0 0 2.815-2.814 2.81 2.81 0 0 0-2.815-2.815Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M262.067 266.704a2.81 2.81 0 0 0-2.815 2.815 2.81 2.81 0 0 0 2.815 2.814 2.81 2.81 0 0 0 2.815-2.814 2.81 2.81 0 0 0-2.815-2.815Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M262.067 266.704a2.81 2.81 0 0 0-2.815 2.815 2.81 2.81 0 0 0 2.815 2.814 2.81 2.81 0 0 0 2.815-2.814 2.81 2.81 0 0 0-2.815-2.815Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg)",
    d: "M117.949 265.975c38.386 0 69.504-31.118 69.504-69.504 0-38.385-31.118-69.503-69.504-69.503s-69.504 31.118-69.504 69.503 31.118 69.504 69.504 69.504"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M117.949 265.975c38.386 0 69.504-31.118 69.504-69.504 0-38.385-31.118-69.503-69.504-69.503s-69.504 31.118-69.504 69.503 31.118 69.504 69.504 69.504Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M117.949 265.975c38.386 0 69.504-31.118 69.504-69.504 0-38.385-31.118-69.503-69.504-69.503s-69.504 31.118-69.504 69.503 31.118 69.504 69.504 69.504Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M117.949 265.975c38.386 0 69.504-31.118 69.504-69.504 0-38.385-31.118-69.503-69.504-69.503s-69.504 31.118-69.504 69.503 31.118 69.504 69.504 69.504Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg)",
    d: "M128.541 265.975c38.386 0 69.504-31.118 69.504-69.504 0-38.385-31.118-69.503-69.504-69.503s-69.503 31.118-69.503 69.503 31.117 69.504 69.503 69.504"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M128.541 265.975c38.386 0 69.504-31.118 69.504-69.504 0-38.385-31.118-69.503-69.504-69.503s-69.503 31.118-69.503 69.503 31.117 69.504 69.503 69.504Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M128.541 265.975c38.386 0 69.504-31.118 69.504-69.504 0-38.385-31.118-69.503-69.504-69.503s-69.503 31.118-69.503 69.503 31.117 69.504 69.503 69.504Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M128.541 265.975c38.386 0 69.504-31.118 69.504-69.504 0-38.385-31.118-69.503-69.504-69.503s-69.503 31.118-69.503 69.503 31.117 69.504 69.503 69.504Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg)",
    d: "M128.541 259.668c34.903 0 63.197-28.294 63.197-63.197 0-34.902-28.294-63.197-63.197-63.197-34.902 0-63.197 28.295-63.197 63.197s28.295 63.197 63.197 63.197"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M128.541 259.668c34.903 0 63.197-28.294 63.197-63.197 0-34.902-28.294-63.197-63.197-63.197-34.902 0-63.197 28.295-63.197 63.197s28.295 63.197 63.197 63.197Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M128.541 259.668c34.903 0 63.197-28.294 63.197-63.197 0-34.902-28.294-63.197-63.197-63.197-34.902 0-63.197 28.295-63.197 63.197s28.295 63.197 63.197 63.197Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M128.541 259.668c34.903 0 63.197-28.294 63.197-63.197 0-34.902-28.294-63.197-63.197-63.197-34.902 0-63.197 28.295-63.197 63.197s28.295 63.197 63.197 63.197Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    d: "M130.297 154.818c18.709 0 34.781 11.67 35.09 28.67H142.92c-2.521-5.098-8.528-8.755-17.258-8.755-6.222 0-11.17 1.723-14.817 4.65-3.646 2.925-5.957 7.025-6.953 11.716l-.129.604h29.206v10.106h-29.207l.13.605c1.01 4.69 3.32 8.789 6.963 11.715s8.585 4.649 14.807 4.649c8.674 0 15.083-3.077 17.29-8.755h22.434c-.17 7.538-4.175 14.626-10.465 19.879-6.428 5.368-15.214 8.791-24.624 8.791-21.38 0-39.007-15.889-41.713-36.45l-.057-.434h-8.939v-10.106h8.939l.057-.435c2.706-20.56 20.333-36.45 41.713-36.45Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeOpacity: 0.2,
    d: "M130.297 154.818c18.709 0 34.781 11.67 35.09 28.67H142.92c-2.521-5.098-8.528-8.755-17.258-8.755-6.222 0-11.17 1.723-14.817 4.65-3.646 2.925-5.957 7.025-6.953 11.716l-.129.604h29.206v10.106h-29.207l.13.605c1.01 4.69 3.32 8.789 6.963 11.715s8.585 4.649 14.807 4.649c8.674 0 15.083-3.077 17.29-8.755h22.434c-.17 7.538-4.175 14.626-10.465 19.879-6.428 5.368-15.214 8.791-24.624 8.791-21.38 0-39.007-15.889-41.713-36.45l-.057-.434h-8.939v-10.106h8.939l.057-.435c2.706-20.56 20.333-36.45 41.713-36.45Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeOpacity: 0.2,
    d: "M130.297 154.818c18.709 0 34.781 11.67 35.09 28.67H142.92c-2.521-5.098-8.528-8.755-17.258-8.755-6.222 0-11.17 1.723-14.817 4.65-3.646 2.925-5.957 7.025-6.953 11.716l-.129.604h29.206v10.106h-29.207l.13.605c1.01 4.69 3.32 8.789 6.963 11.715s8.585 4.649 14.807 4.649c8.674 0 15.083-3.077 17.29-8.755h22.434c-.17 7.538-4.175 14.626-10.465 19.879-6.428 5.368-15.214 8.791-24.624 8.791-21.38 0-39.007-15.889-41.713-36.45l-.057-.434h-8.939v-10.106h8.939l.057-.435c2.706-20.56 20.333-36.45 41.713-36.45Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M97.347 130.068h10.607"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M97.347 130.068h10.607M97.347 130.068h10.607"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M88.944 133.287h10.62"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M88.944 133.287h10.62M88.944 133.287h10.62"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M79.965 138.265h10.62"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M79.965 138.265h10.62M79.965 138.265h10.62"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M71.353 144.885H81.96"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M71.353 144.885H81.96M71.353 144.885H81.96"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M62.19 155.009h10.62"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M62.19 155.009h10.62M62.19 155.009h10.62"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M54.907 167.141h10.62"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M54.907 167.141h10.62M54.907 167.141h10.62"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M50.242 180.613h10.62"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M50.242 180.613h10.62M50.242 180.613h10.62"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M48.262 196.159H58.87"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M48.262 196.159H58.87M48.262 196.159H58.87"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M50.45 213.099h10.607"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M50.45 213.099h10.607M50.45 213.099h10.607"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M54.385 224.734h10.62"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M54.385 224.734h10.62M54.385 224.734h10.62"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M75.079 251.212h10.62"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M75.079 251.212h10.62M75.079 251.212h10.62"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M83.704 256.945h10.62"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M83.704 256.945h10.62M83.704 256.945h10.62"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeWidth: 1.424,
    d: "M93.713 261.662h10.62"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 1.424,
    d: "M93.713 261.662h10.62M93.713 261.662h10.62"
  })));
};
export default SvgSandWatch;